import { AlertDialog } from '../../AlertDialog/AlertDialog';
import { useInstallmentsTranslation } from './i18n';

export interface RegenerateInstallmentsModalProps {
  open: boolean;
  /** Mutación en vuelo: bloquea los botones y muestra spinner en confirmar. */
  isProcessing: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Modal de confirmación de regeneración del plan de cuotas (FEAT-105-7.03).
 *
 * Envuelve el `AlertDialog` del kit (`type="warning"`, ADAPTACIÓN A4) advirtiendo
 * que se descartarán los ajustes manuales.
 */
export function RegenerateInstallmentsModal({
  open,
  isProcessing,
  onConfirm,
  onClose,
}: RegenerateInstallmentsModalProps) {
  const { t } = useInstallmentsTranslation();

  return (
    <AlertDialog
      isOpen={open}
      type="warning"
      title={t('installments.modal.title')}
      description={t('installments.modal.body')}
      cancelText={t('installments.modal.cancel')}
      confirmText={t('installments.modal.confirm')}
      isProcess={isProcessing}
      preventCloseOnOverlayClick
      onCancel={onClose}
      onConfirm={onConfirm}
    />
  );
}
